export default "__VITE_ASSET__KSairRtk__"